/**
 * @generated SignedSource<<d08f09989750d94515a50ca1d2ae3f8c>>
 * @relayHash 9934a792536866271887cc4b166b37b3
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 9934a792536866271887cc4b166b37b3

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "idcc"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "siret"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "idcc",
        "variableName": "idcc"
      },
      {
        "kind": "Variable",
        "name": "siret",
        "variableName": "siret"
      }
    ],
    "concreteType": "CcnRecommandation",
    "kind": "LinkedField",
    "name": "ccnRecommandations",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "offerName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "offerType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "idccs",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "oav",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "VAD",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "excluded",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CcnRecommandationsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CcnRecommandationsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "9934a792536866271887cc4b166b37b3",
    "metadata": {},
    "name": "CcnRecommandationsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

node.hash = "4f1341f0a0e0b21209948ce4776c026a";

export default node;
